import { Injectable } from '@angular/core';
import { ModalConfig } from '../models/modal-config';
import { Subject } from 'rxjs';

interface ModalRequest {
  config: ModalConfig;
  focusOrigin: HTMLElement | null;
  resolve: (value: any) => void;
}

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private readonly _requests = new Subject<ModalRequest>();
  requests$ = this._requests.asObservable();

  open(config: ModalConfig): Promise<any> {
    const focusOrigin = this.getFocusOrigin();

    return new Promise((resolve) => {
      this._requests.next({ config, focusOrigin, resolve });
    });
  }

  private getFocusOrigin(): HTMLElement | null {
    if (typeof document === 'undefined') {
      return null;
    }

    let activeElement: Element | null = document.activeElement;

    while (activeElement?.shadowRoot?.activeElement) {
      activeElement = activeElement.shadowRoot.activeElement;
    }

    return activeElement instanceof HTMLElement &&
      activeElement !== document.body &&
      activeElement !== document.documentElement
      ? activeElement
      : null;
  }
}
